import React from 'react'
import { Container } from 'react-bootstrap'
import SectionHeader from '../sectionHeader'
import SectionSubHeader from '../sectionSubHeader'
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
const OurIndustries = () => {
  const navigate = useNavigate();
  return (
    <div className='volto-section our-industries'>
        <Container>
            <SectionHeader mainText1="SERVING" mainText2="SECTORS" />
            <SectionSubHeader headerText="Our Industries" />
            <div className="volto-mansory-grid">
                <div className='mansory-grid-card' onClick={() => navigate("/industries/banking-and-finance")}>
                  <div className='layer'>
                    <h2>Banking & <br /> Financial <BsArrowRight /></h2>
                  </div>
                <img src="images/banking.webp" alt="banking-financial" />
                </div>
                <div className='mansory-grid-card' onClick={() => navigate("/industries/travel-and-hospitality")}>
                <div className='layer'>
                    <h2>Travel &  <br />
                    Hospitality  <BsArrowRight /></h2>
                  </div>
                <img src="images/travel.webp" alt="travel" />
                </div>
                <div className='mansory-grid-card' onClick={() => navigate("/industries/energy-utilities")}>
                <div className='layer'>
                    <h2>Energy & <br />
                    Utilities  <BsArrowRight /></h2>
                  </div>
                <img src="images/energy.webp" alt="energy" />
                </div>
                <div className='mansory-grid-card' onClick={() => navigate("/industries/healthcare")}>
                <div className='layer'>
                    <h2>Health Care  <BsArrowRight /></h2>
                  </div>
                <img src="images/healthcare.webp" alt="helathcare" />
                </div>
                <div className='mansory-grid-card' onClick={() => navigate("/industries/life-science")}>
                <div className='layer'>
                    <h2>Life Science  <BsArrowRight /></h2>
                  </div>
                <img src="images/life-science.webp" alt="life-science" />
                </div>
                <div className='mansory-grid-card' onClick={() => navigate("/industries/manufacturing")}>
                <div className='layer'>
                    <h2>Manufacturing <BsArrowRight /></h2>
                  </div>
                <img src="images/Manufacturing.webp" alt="Manufacturing" />
                </div>
                <div className='mansory-grid-card' onClick={() => navigate("/industries/hi-tech")}>
                <div className='layer'>
                    <h2>Hi-Tech <BsArrowRight /></h2>
                  </div>
                <img src="images/hitech.webp" alt="hitech.webp" />
                </div>
               
            </div>
            
        </Container>
      
    </div>
  )
}

export default OurIndustries
